<h2 mat-dialog-title>{{ data.fileName }}</h2>
<mat-dialog-content class="dialog-content">
  <iframe
    [src]="sanitizedUrl"
    width="100%"
    height="700px"
    style="border:none;"
  ></iframe>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
